import React from 'react';
import { Paper, PaperContent } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { ReactComponent as IconClipboardList } from 'svg/clipboard-list-solid.svg';

import s from './styles.module.scss';

const EmptyPage = ({ t, text }) => (
  <Paper>
    <PaperContent className={s.emptyReportContent} data-test="reportPlaceholder">
      <div className={s.iconWrapper}>
        <IconClipboardList />
      </div>
      {t(text)}
    </PaperContent>
  </Paper>
);

EmptyPage.propTypes = {
  text: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(EmptyPage);
